<template>
  <div v-loading="loading"
       element-loading-text="数据加载中"
       element-loading-spinner="el-icon-loading"
       style="width: 100%;min-height: 400px;padding: 5px;"
  >
    <template v-for="(mainItem,index) in receipts.invoice">
      <div :key="index">
        <CustomerInvoiceTemp :ref="'customerInvoice'+index" :main-item.sync="mainItem"
                             :invoice-content-options="invoice_content"/>
      </div>
    </template>
    <div class="submit-box">
      <el-row>
        <el-col :span="24">
          <el-button type="primary" @click="submitInvoice" style="margin-right: 24px;" :loading="submitInvoiceLoading">
            确认申请
          </el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
import {gFunc} from "@/globalFunc";
import {getSaleCustomerInvoiceInfo, getStrikeOrders} from "@/api/bill";
import {getOptionsForSelect} from "@/api/option";
// import {mTofixed} from "@/views/adOrder/index";
import {postInvoicesStore} from "@/api/adOrder";
import {getByCustomerSaleId} from "@/api/customers";
import CustomerInvoiceTemp from "@/views/bill/components/CustomerInvoiceTemp";
import {splitAmountByRatio} from "@/views/bill/components/invoiceMoneyAlloc";

export default {
  name: "InvoiceApply",
  components: {CustomerInvoiceTemp},
  data() {
    return {
      loading: false,//数据加载中
      // 发票
      receipts: {
        invoice: [],
      },
      dialogInvoice: false,
      submitInvoiceLoading: false,
      invoice_content: [],
      optionsItem: ["invoice"]
    }
  },
  methods: {
    moneyFormat(value) { // 金额 格式化
      return gFunc.numberFormat(value, 2, '.', ',')
    },
    //选项配置
    getOptions: async function (options) {
      const res = await getOptionsForSelect(options)
      if (res.model) {
        this.invoice_content = res.model.invoice || [];
      }
    },
    /**
     * 申请发票前
     * 把冲账订单的捞出来
     * @param data
     * @returns {Promise<*[]>}
     */
    async showReceiptBefore(data) {
      const order_nos = data.map(_ => {
        return _.order_no
      })
      const response = await getStrikeOrders({order_nos})
      return response.model || []
    },
    // 发票相关
    async showReceipt(multipleSelection) {
      //发票内容获取
      if (this.invoice_content.length === 0)
        await this.getOptions(this.optionsItem);

      let _selectItems = multipleSelection
      if (!_selectItems || (Array.isArray(_selectItems) && _selectItems.length <= 0)) {
        this.$emit('showErrorEvent', "至少选择一条广告订单")
        return false;
      }

      this.loading = true
      const strike_orders = await this.showReceiptBefore(_selectItems);
      const orders = [..._selectItems, ...strike_orders]

      this.receipts.invoice = [];
      let tempList = {};
      let error_msg = false
      for (let index = 0; index < orders.length; index++) {
        let el = orders[index]
        if (el.order_type && !(el.order_type === "普通类型" || el.order_type === "regular")) {
          error_msg = '冲账订单不能申请开票';
          break;
        } else if (el.is_can_invoice && el.is_can_invoice === 'N') {
          error_msg = `该订单已全部开票，不可再申请开票`;
          break;
        } else if (el.bool_undo) {
          error_msg = '存在已撤单订单，请去除勾选后再次申请';
          break;
        }

        //开票信息唯一键：客户ID+销售ID 改为 客户ID（需求改动时间:20210617）
        // let uqKey = el.customer.id + '-' + el.sale_id;
        let uqKey = el.customer_id;
        if (!tempList[uqKey]) {
          tempList[uqKey] = [];
        }
        let _order = {
          id: el.id,
          order_no: el.order_no,
          sale_id: el.sale_id,
          customer_id: el.customer_id,
          customer_name: el.customer_name,
          payment_account: el.payment_account,
          invoice_money_surplus: el.invoice_money_surplus || 0,
          invoice_money_done: el.invoice_money_done || 0,
          invoice_money_occupy: el.invoice_money_occupy || 0,
        };
        tempList[uqKey].push(_order);
      }

      if (error_msg) {
        this.$emit('showErrorEvent', error_msg)
        return false;
      }

      // 表单默认数据组装
      for (const key in tempList) {
        //每个客户的发票信息
        let customerId = key;
        let customerOrderArr = tempList[key]
        let payment_account_total = 0, invoice_money_surplus_total = 0, invoice_money_done_total = 0,
            invoice_money_occupy_total = 0

        if (Array.isArray(customerOrderArr)) {
          customerOrderArr.map(_ => {
            payment_account_total = this.$bigNumber(payment_account_total).plus(_.payment_account).toNumber() // 总含税收入
            invoice_money_surplus_total = this.$bigNumber(invoice_money_surplus_total).plus(_.invoice_money_surplus).toNumber() // 总剩余
            invoice_money_done_total = this.$bigNumber(invoice_money_done_total).plus(_.invoice_money_done).toNumber() // 总已开票
            invoice_money_occupy_total = this.$bigNumber(invoice_money_occupy_total).plus(_.invoice_money_occupy).toNumber() // 总占用
          })
        }

        let obj = {
          customer_id: customerId,
          customer_name: customerOrderArr[0]['customer_name'],
          sale_id: customerOrderArr[0]['sale_id'],
          payment_account: payment_account_total,
          invoice_money_surplus: invoice_money_surplus_total,
          invoice_money_done: invoice_money_done_total,
          invoice_money_occupy: invoice_money_occupy_total,
          children: [
            {
              orders: customerOrderArr,
              customer_id: customerId,
              customer_name: customerOrderArr[0]['customer_name'],
              invoice_title: "",
              tax_id: "",
              address: "",
              telephone: "",
              bank_name: "",
              bank_amount: "",
              amount_money: invoice_money_surplus_total,
              type: "",
              content: "",
              contact_name: '',
              contact_phone: '',
              contact_email: '',
              contact_province: '',
              contact_city: '',
              contact_area: '',
              contact_address: '',
              provinces: [],
              contact_provinces: [],
              // children: []
            }
          ]
        }

        //获取发票信息
        let {info, contact} = await getSaleCustomerInvoiceInfo({
          customer_id: obj.customer_id,
          sale_id: obj.sale_id
        }).then(res => {
          return res.model;
        })
        let cIndex = 0
        //基础信息
        obj.children[cIndex].customer_name = info.customer_name;
        obj.children[cIndex].customer_id = info.customer_id;
        obj.children[cIndex].invoice_title = info.invoice_title;
        obj.children[cIndex].tax_id = info.tax_id;//税号
        obj.children[cIndex].address = `${info.province || ''}${info.city || ''}${info.area || ''}${info.address || ''}`;
        obj.children[cIndex].telephone = info.telephone;
        obj.children[cIndex].bank_name = info.bank_name;
        obj.children[cIndex].bank_amount = info.bank_amount;
        obj.children[cIndex].type = info.invoice_type;
        //接收方式
        obj.children[cIndex].contact_name = contact.contact_name;
        obj.children[cIndex].contact_phone = contact.contact_phone;
        obj.children[cIndex].contact_email = info.invoice_email;
        obj.children[cIndex].contact_address = `${contact.contact_province || ''}${contact.contact_city || ''}${contact.contact_area || ''}${contact.contact_address || ''}`;


        if (Array.isArray(this.invoice_content)) {
          const hasValue = this.invoice_content.some(tmp => tmp.value === info.invoice_content);
          obj.children[cIndex].content = hasValue ? info.invoice_content : null;//发票内容
        } else {
          obj.children[cIndex].content = null;//发票内容
        }

        // 默认按各订单剩余金额占比分配发票金额（可在“订单信息”表中手动调整）
        const defaultAmounts = splitAmountByRatio(customerOrderArr.map(order => order.invoice_money_surplus || 0), obj.children[cIndex].amount_money);
        obj.children[cIndex].orders.forEach((order, orderIndex) => {
          order.invoice_money = defaultAmounts[orderIndex] || '0.00';
        });

        this.receipts.invoice.push(obj);
        this.loading = false
      }
    },
    invoiceMoneyInput(val, index, cIndex) {
      let _val = val.split(',').join('')
      // eslint-disable-next-line
      if (isNaN(Number(_val))) {

      } else {
        let _indexOf = _val.indexOf('.')
        if (_indexOf >= 0) {
          if ((_val.length - 1 - _indexOf <= 2)) {
            this.receipts.invoice[index].children[cIndex].amount_money = _val
          }
        } else {
          this.receipts.invoice[index].children[cIndex].amount_money = _val
        }
      }
    },
    async submitInvoice() {
      let _invoice = this.receipts.invoice;
      let _newInvoice = [];
      let has_error = false;
      for (let index = 0; index < _invoice.length; index++) {
        const children = _invoice[index].children
        _newInvoice = [..._newInvoice, ...children];

        // 校验发票填写
        const refCustomerInvoice = this.$refs['customerInvoice' + index] || false
        if (refCustomerInvoice && refCustomerInvoice[0] && !refCustomerInvoice[0].validateForm()) {
          has_error = true
        }
      }
      if (has_error) {
        this.showToast({h: this, icon: "el-icon-error", text: '数据填写不完善', duration: 2000});
        return false;
      }

      // 校验：每张发票下各订单分配的开票金额之和须等于发票金额
      // for (let index = 0; index < _newInvoice.length; index++) {
      //   const error_msg = this.validateOrdersMoney(_newInvoice[index]);
      //   if (error_msg) {
      //     this.showToast({h: this, icon: "el-icon-error", text: error_msg, duration: 3000});
      //     return false;
      //   }
      // }

      // 精简提交字段：只提交后端校验 / 落库 / 后续使用到的字段
      const _submitInvoice = this.buildSubmitInvoice(_newInvoice);

      this.submitInvoiceLoading = true
      const response = await postInvoicesStore(_submitInvoice);
      this.submitInvoiceLoading = false;

      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 2000});
        return false
      }
      this.showToast({h: this, icon: "el-icon-success", text: "申请成功", duration: 2000});
      this.$emit('submited')
    },
    closeDialog() {
      this.$emit('closeEvent')
    },
    /**
     * 校验单张发票下各订单分配的开票金额
     * @param invoice 发票对象（含 orders / amount_money）
     * @returns {string} 错误信息，"" 表示通过
     */
    validateOrdersMoney(invoice) {
      if (!invoice || !Array.isArray(invoice.orders) || invoice.orders.length === 0) {
        return '';
      }
      let allocated = this.$bigNumber(0);
      for (let i = 0; i < invoice.orders.length; i++) {
        const order = invoice.orders[i];
        const raw = (order.invoice_money === '' || order.invoice_money === null || order.invoice_money === undefined) ? 0 : order.invoice_money;
        const money = this.$bigNumber(raw);
        if (money.isNaN() || money.lt(0)) {
          return `订单【${order.order_no}】的开票金额不合法`;
        }
        if (money.gt(this.$bigNumber(order.invoice_money_surplus || 0).plus(0.009))) {
          return `订单【${order.order_no}】的开票金额不能大于其剩余可开票金额 ${this.moneyFormat(order.invoice_money_surplus || 0)}`;
        }
        order.invoice_money = money.toFixed(2);
        allocated = allocated.plus(order.invoice_money);
      }
      const total = this.$bigNumber(invoice.amount_money || 0);
      if (allocated.minus(total).abs().gte(0.005)) {
        return `【${invoice.customer_name || '客户'}】各订单开票金额之和（${this.moneyFormat(allocated.toNumber())}）须等于发票金额（${this.moneyFormat(total.toNumber())}）`;
      }
      return '';
    },
    /**
     * 精简提交数据：只保留后端需要的字段
     * - 发票：StoreRequest 必填项 + Invoice::$filed 中由前端录入的字段
     * - 订单：id / order_no / payment_account（后端校验必填）+ invoice_money（每单分配金额）
     * @param invoices 发票数组
     * @returns {Array}
     */
    buildSubmitInvoice(invoices) {
      return (invoices || []).map(invoice => {
        return {
          customer_id: invoice.customer_id,
          customer_name: invoice.customer_name,
          invoice_title: invoice.invoice_title,
          tax_id: invoice.tax_id,
          address: invoice.address,
          telephone: invoice.telephone,
          bank_name: invoice.bank_name,
          bank_amount: invoice.bank_amount,
          amount_money: invoice.amount_money,
          type: invoice.type,
          content: invoice.content,
          contact_name: invoice.contact_name,
          contact_phone: invoice.contact_phone,
          contact_email: invoice.contact_email,
          contact_address: invoice.contact_address,
          remark: invoice.remark,
          orders: (invoice.orders || []).map(order => {
            return {
              id: order.id,
              order_no: order.order_no,
              payment_account: order.payment_account,
              invoice_money: order.invoice_money,
            }
          }),
        }
      })
    },
    async editCustomer(customer_id, sale_id) {

      let {id} = await getByCustomerSaleId({customer_id: customer_id, sale_id: sale_id}).then(res => {
        return res.model
      })
      this.$notify.success(`customer_id:${customer_id},sale_id:${sale_id},id:${id}`)
      if (id) {
        const {href} = this.$router.resolve({
          name: `editCustom`,
          params: {id: id}//customer_id: row.customer_id, sale_id: row.sale_id
        });
        window.open(href, "_blank");
      }

    }
  }
}
</script>

<style scoped>
.submit-box {
  margin-bottom: 24px;
  border: 1px solid #ebeef5;
  padding: 12px;
  text-align: center;
}

</style>
